var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showEdit)?_c('li',{on:{"click":_vm.edit}},[_vm._v(" Upravit objekt ")]):_vm._e(),(_vm.showRemove)?_c('li',{on:{"click":_vm.remove}},[_vm._v(" Odebrat objekt ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }